/**
 * Birtvy-local literal-copy guard for style prompts.
 *
 * Why this exists: a design system is a TREATMENT read off someone's deck, but the synthesis writes the
 * source's own chrome into `patterns` and `guideline` (it is asked to describe footers/eyebrows, and it is
 * fed each source slide's literal footer text), so generation happily reprints the source's brand name and
 * year in a slide footer. The API's existing "don't copy literal text" language lives in the flow route's
 * buildStyleInstruction, which only runs when reference IMAGES are attached — a design-system generation
 * sends none, so that branch never fires.
 *
 * We can't fix it in utils/moodboardStyle.ts or the shared routes: the old canvas (/canvas-old) imports the
 * same helpers, so this appends the missing rule on Birtvy's side only.
 */
export const BIRTVY_STYLE_LITERAL_GUARD = [
  'The style above is a TREATMENT ONLY — never reproduce literal content from whatever reference it was read from.',
  "Never write that reference's brand, company or product name, its dates, years, page numbers, slide titles, or any footer / eyebrow / running-header wording into a slide, unless that text genuinely belongs to THIS deck's own subject.",
  'Where a rule names a chrome element (footer, eyebrow, page number, running header), reproduce only its POSITION, SIZE and STYLE — fill it with this deck\'s own words, or leave it out.',
].join('\n')

/** Append the guard to a style prompt block. An empty block stays empty (nothing to qualify). */
export function withBirtvyStyleGuard(block: string): string {
  return block ? `${block}\n\n${BIRTVY_STYLE_LITERAL_GUARD}` : ''
}
